/* src/modules/profile/Scene.js */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import ChangePasswordCard from './cards/ChangePasswordCard';
import NotificationPreferenceCard from './cards/NotificationPreferenceCard';
import UserInfoCard from './cards/UserInfoCard';

const Profile = () => (
  <Grid container spacing={16}>
    <Grid item xs={12}>
      <UserInfoCard />
    </Grid>
    <Grid item xs={12}>
      <ChangePasswordCard />
    </Grid>
    <Grid item xs={12}>
      <NotificationPreferenceCard />
    </Grid>
  </Grid>
);

export default withStyles({})(Profile);



// WEBPACK FOOTER //
// ./src/modules/profile/Scene.js